import React, {
  useContext, useMemo, useState, useCallback, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { EmailContext } from '../context/Context';
import api from '../../../api/req';
import meta from '../../../meta';
import { CiatAppContext } from '../../../providers';
import useNewEmails from './hook';

function EmailProvider({ children }) {
  const { auth } = useContext(CiatAppContext);

  const [emails, setEmails] = useState([]);

  const timerId = useRef(null);

  const fetchEmails = useCallback(async () => {
    const loader = async () => {
      const r = await api.get(meta.app.email.backendURL, auth);
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    };
    loader()
      .then((rData) => {
        setEmails(rData);
      });
  }, [auth]);

  useEffect(() => {
    const loader = () => {
      fetchEmails();
      timerId.current = setTimeout(loader, 5 * 60 * 1000);
    };
    loader();
    return () => clearTimeout(timerId.current);
  }, [fetchEmails]);

  const contextValue = useMemo(
    () => (
      {
        emails,
        fetchEmails,
      }),
    [emails, fetchEmails],
  );
  useNewEmails(emails);

  return (
    <EmailContext.Provider value={contextValue}>
      {children}
    </EmailContext.Provider>
  );
}

EmailProvider.propTypes = { children: PropTypes.node.isRequired };

export default EmailProvider;
